import * as Profile from 'app/entities/Profile';
import * as UserNotification from 'app/entities/UserNotification';
import ActionTypes from 'app/viewport/ActionTypes';
import TrackActions from 'app/track/TrackActions';
import { isNotificationsDropdownOpen } from 'app/viewport/Selectors';
import { isRead } from 'app/viewport/utils/notification';

const actions = {
  toggleNotificationsDropdown() {
    return (dispatch, getState) => {
      const state = getState();
      if (isNotificationsDropdownOpen(state)) {
        const notifications = UserNotification.selectors.all
          .notDismissed(state)
          .map(entity => UserNotification.selectors.data(entity));
        dispatch(actions.markNotificationsRead(notifications));
        dispatch({ type: ActionTypes.CLOSE_NOTIFICATIONS_DROPDOWN });
      } else {
        dispatch({ type: ActionTypes.OPEN_NOTIFICATIONS_DROPDOWN });
      }
    };
  },

  markNotificationsRead(notifications) {
    return dispatch => {
      const unread = notifications.filter(n => !isRead(n.notificationStatus));

      if (unread.length > 0) {
        dispatch(UserNotification.actions.markNotificationsRead(unread));
        dispatch(
          TrackActions.track('in-app notification: notifications read', {})
        );
      }
    };
  },

  notificationCta(notification) {
    return (dispatch, getState) => {
      const state = getState();
      if (isNotificationsDropdownOpen(state)) {
        dispatch(actions.toggleNotificationsDropdown());
      }
      if (notification.action) {
        dispatch(
          notification.action(Profile.selectors.all.currentProfileId(state))
        );
      }
      dispatch(
        TrackActions.track('in-app notification: CTA click', {
          name: notification.title,
        })
      );
    };
  },

  dismissNotification(notificationId) {
    return (dispatch, getState) => {
      const state = getState();
      const notifications = UserNotification.selectors.all.notDismissed(state);

      // If this is the last notification that we are dismissing, close
      // the menu, so the user doesn't see the 'no notifications' banner.
      if (notifications.length === 1 && isNotificationsDropdownOpen(state)) {
        dispatch(actions.toggleNotificationsDropdown());
      }

      dispatch(UserNotification.actions.dismiss(notificationId));
    };
  },
};

export default actions;
